import {
  GET_ACTUALITY_SUCCESS,
  GET_ACTUALITY_BY_ID_SUCCESS,
  GET_GOVERNANCE_SUCCESS,
  GET_GOVERNANCE_BY_ID_SUCCESS,
  GET_DOCUMENT_SOLLICITE_SUCCESS,
  GET_DOCUMENTS_WAIT_VALIDATION_SUCCESS,
  GET_DOCUMENTS_BY_CONTROL_ID_SUCCESS,
  GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS_SUCCESS,
  SET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS,
  GET_DOCUMENTS_ASSOCIATE_RESPONSE_SUCCESS,
  POST_FILE_ACTUALITY_SUCCESS,
} from "./constants"

const initialState = {
  actualityList: [],
  actualitySelect: {},
  governanceList: [],
  governanceSelect: {},
  documentList: [],
  controlPlanWithArchivedControls: [],
  documentsWaitingValidation: [],
  documentsAssociateResponseControl: [],
}

function dataDocumentManagementReducer(state = initialState, { type, payload }) {
  switch (type) {
    //***************************** ACTUALITY *******************************
    case GET_ACTUALITY_SUCCESS:
      return {
        ...state,
        actualityList: payload.body,
      }
    case GET_ACTUALITY_BY_ID_SUCCESS:
      return {
        ...state,
        actualitySelect: payload.body,
      }
    case POST_FILE_ACTUALITY_SUCCESS:
      return {
        ...state,
        listFilesActuality: [...state.listFilesActuality, payload],
      }
    //**************************** GOVERNANCE *******************************
    case GET_GOVERNANCE_SUCCESS:
      return {
        ...state,
        governanceList: payload.body,
      }
    case GET_GOVERNANCE_BY_ID_SUCCESS:
      return {
        ...state,
        governanceSelect: payload.body,
      }
    //************************ DOCUMENT_SOLLICITE ***************************
    case GET_DOCUMENT_SOLLICITE_SUCCESS:
      return {
        ...state,
        documentList: payload.body,
      }
    case GET_DOCUMENTS_BY_CONTROL_ID_SUCCESS:
      return {
        ...state,
        documentList: payload.body,
      }
    case GET_DOCUMENTS_WAIT_VALIDATION_SUCCESS:
      return {
        ...state,
        documentsWaitingValidation: payload.body,
      }
    //************************* CONTROL_ARCHIVED ****************************
    case GET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS_SUCCESS:
      return {
        ...state,
        controlPlanWithArchivedControls: payload.body,
      }
    case SET_CONTROL_PLAN_WITH_ARCHIVED_CONTROLS:
      return {
        ...state,
        controlPlanWithArchivedControls: payload,
      }
    //************************* DOCUMENTS ASSOCIATE RESPONSE CONTROL ****************************
    case GET_DOCUMENTS_ASSOCIATE_RESPONSE_SUCCESS:
      return {
        ...state,
        documentsAssociateResponseControl: payload,
      }
    default:
      return state
  }
}

export default dataDocumentManagementReducer
